import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-ehms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-ehms.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationDetailsEhmsConstants } from "./create-application-details-ehms.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { EhApplicationTypeEnum } from "../../../../../shared/models/application/eh/eh-application-type-enum.model";
import { DatePipe } from "@angular/common";
import { SelectedApplicationService } from "../../../../../shared/services/selected-application/selected-application.service";
import { LookupConstants } from "src/app/shared/constants/lookup.constants";
let CreateApplicationDetailsEhmsComponent = class CreateApplicationDetailsEhmsComponent extends CreateApplicationViewBaseComponent {
    datePipe;
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    selectedApplicationService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsEhmsConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = CreateApplicationDetailsEhmsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    startDateFormControlName = CreateApplicationDetailsEhmsConstants.START_DATE_FORM_CONTROL_NAME;
    communicationMethodFormControlName = CreateApplicationDetailsEhmsConstants.COMMUNICATION_METHOD_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsEhmsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypeLabel = CreateApplicationDetailsEhmsConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = CreateApplicationDetailsEhmsConstants.DESCRIPTION_LABEL;
    startDateLabel = CreateApplicationDetailsEhmsConstants.START_DATE_LABEL;
    communicationMethodLabel = CreateApplicationDetailsEhmsConstants.COMMUNICATION_METHOD_LABEL;
    applicationTypes = [];
    communicationTypes = [];
    constructor(datePipe, createApplicationService, aflaModuleStrategyService, appController, selectedApplicationService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.datePipe = datePipe;
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.applicationTypes = [];
        for (const type in EhApplicationTypeEnum) {
            if (isNaN(Number(type)))
                // @ts-ignore
                this.applicationTypes.push({ value: type, name: EhApplicationTypeEnum[type] });
        }
        this.communicationTypes = LookupConstants.COMMUNICATION_MECHANISM;
        this.initForm();
        this.getMetadata();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm.get(this.startDateFormControlName).setValue(this.datePipe.transform(new Date(), "yyyy-MM-dd"));
    }
    loadMetadata(stepMeta) {
    }
    static ctorParameters = () => [
        { type: DatePipe },
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsEhmsComponent = __decorate([
    Component({
        selector: "app-create-application-details-ehms",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsEhmsComponent);
export { CreateApplicationDetailsEhmsComponent };
